export default __webpack_public_path__ + "static/media/litho-landing-page-img-07.a9824163.jpg";